var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedIn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    fill: "none",
    viewBox: "0 0 42 43",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.7,
    d: "M20.97 41.341c10.954 0 19.833-8.88 19.833-19.833S31.923 1.676 20.97 1.676 1.138 10.556 1.138 21.508c0 10.954 8.88 19.833 19.832 19.833Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M25.315 17.168a5.667 5.667 0 0 1 5.666 5.666v6.611h-3.777v-6.61a1.89 1.89 0 0 0-3.778 0v6.61h-3.778v-6.61a5.666 5.666 0 0 1 5.667-5.667M15.87 18.113h-3.777v11.333h3.777zM13.982 15.282a1.889 1.889 0 1 0 0-3.778 1.889 1.889 0 0 0 0 3.778"
  })));
};
export default SvgLinkedIn;